import { cleanJsonEmptyValues } from '../../../../../utils/formatUtils';
import { NewContractFields } from '../../../../Interfaces/Accounting/ACForms.interfaces';

export const buildEmptyContractForm = (data: NewContractFields) =>
  Object.keys(data).reduce(
    (values, key) => ({ ...values, [key]: undefined }),
    {} as NewContractFields
  );

export const reviveContractDraftPayload = (
  payload: Partial<Omit<NewContractFields, 'attachments'>>
): Partial<NewContractFields> => {
  const { startDate, dateOrdered, insuranceDateOrdered, ...otherFields } =
    payload;

  return {
    ...otherFields,
    startDate: startDate ? new Date(startDate) : undefined,
    dateOrdered: dateOrdered ? new Date(dateOrdered) : undefined,
    insuranceDateOrdered: insuranceDateOrdered
      ? new Date(insuranceDateOrdered)
      : undefined,
  };
};

export const buildContractDraftPayload = (
  data: NewContractFields
): NewContractFields => {
  const { processGroup, reviewerGroup, fieldPS } = data;

  return {
    ...data,
    prState: data.state,
    processGroup: processGroup === 'TBD' ? undefined : processGroup,
    reviewerGroup: reviewerGroup === 'TBD' ? undefined : reviewerGroup,
    fieldPS: fieldPS === 'TBD' ? undefined : fieldPS,
  };
};

export const buildContractDraftFormData = (
  companyID: string,
  body: NewContractFields,
  removeAttachments?: string[]
) => {
  const { attachments, ...otherFields } = body;
  const formData = new FormData();

  attachments?.forEach((file) => {
    formData.append('attachments', file);
  });

  formData.append('companyID', companyID);
  formData.append('payload', JSON.stringify(cleanJsonEmptyValues(otherFields)));

  if (removeAttachments?.length) {
    formData.append('removeAttachments', JSON.stringify(removeAttachments));
  }

  return formData;
};
